import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class ListMembersService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  listMembers(sectionId: string, userType : string, activeUsersOnly : boolean, includeClosedSections : boolean = false) {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({ 'Content-Type': 'application/json'})
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var params = new HttpParams();
    params = params
      .set('userType', userType)
      .set('includeClosedSections', includeClosedSections);

    if (activeUsersOnly){
      params = params.set("activeUsersOnly", "true");
    }
    else{
      params = params.set("activeUsersOnly", "false");
    }

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/members`, { params: params, headers: headers});
  }
}
